export function timelineTarget(item, dealId) {
  const [source, id] = (item.id || '').split(':')
  if (!id) return null
  if (item.conversation?.id) return { kind: 'conversation', label: 'Abrir conversa' }
  if (source === 'note' || item.title === 'Nota adicionada') return { kind: 'details', label: 'Abrir nota' }
  if (source === 'deal_activity') return { kind: 'task', id, label: 'Abrir tarefa' }
  // Atividades exclusivas do contato não são aceitas pelo editor de tarefas do negócio.
  if (source === 'activity') return { kind: 'details', label: 'Abrir atividade' }
  if (source === 'lead') return { href: `/comercial/leads/${encodeURIComponent(id)}`, label: 'Abrir contato' }
  if (source === 'company') return { href: `/comercial/empresas/${encodeURIComponent(id)}`, label: 'Abrir empresa' }
  if (['deal', 'deal_status', 'deal_move'].includes(source)) {
    const targetId = source === 'deal_move' ? item.relationship?.deal?.id || item.deal_id || dealId : id
    return targetId ? { href: `/comercial/pipelines?deal=${encodeURIComponent(targetId)}`, label: 'Abrir negócio' } : null
  }
  if (['tracker', 'ad_lead'].includes(source)) return { kind: 'details', label: 'Ver detalhes do evento' }
  return null
}
